var _desc, _rect, _circle, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogNetsuiteAutomation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "NetSuite automation workflow illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Automated ERP workflow moving through approval steps.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "#06131d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 605,
    cy: 350,
    r: 255,
    fill: "#0e7490",
    opacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 350h780",
    stroke: "#155e75",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325 350h185m180 0h185",
    stroke: "#22d3ee",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 240,
    width: 210,
    height: 220,
    rx: 30,
    fill: "#0f172a",
    stroke: "#14b8a6",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 495,
    y: 240,
    width: 210,
    height: 220,
    rx: 30,
    fill: "#0f172a",
    stroke: "#22d3ee",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 240,
    width: 210,
    height: 220,
    rx: 30,
    fill: "#0f172a",
    stroke: "#14b8a6",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205 312h100M205 352h74M205 392h116M550 312h100M550 352h74M550 392h116M895 312h100M895 352h74M895 392h116",
    stroke: "#cbd5e1",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M420 307l43 43-43 43M765 307l43 43-43 43",
    fill: "none",
    stroke: "#14b8a6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 535,
    r: 52,
    fill: "#14b8a6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M575 535l17 17 35-42",
    fill: "none",
    stroke: "#ecfeff",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogNetsuiteAutomation);
export default __webpack_public_path__ + "static/media/blog-netsuite-automation.2f0af1fae52a80d966972e5e1a2a6bee.svg";
export { ForwardRef as ReactComponent };